import { MUIChip } from "@abb/arcadia-ui-react"
import type { ComponentProps } from "react"
import { RoleRequestApprovalStatusEnum } from "../models/RoleRequestApproval"

type ChipProps = ComponentProps<typeof MUIChip>

export function getRoleRequestApprovalStatusProps(
  status: RoleRequestApprovalStatusEnum
): ChipProps {
  let props: ChipProps = {
    label: `${RoleRequestApprovalStatusEnum[status]}`,
    size: 32,
  }

  switch (status) {
    case RoleRequestApprovalStatusEnum.Approved:
      props = { ...props, leadingIconName: "icon_abb_dias icon-abb_completed-check" }
      break
    case RoleRequestApprovalStatusEnum.Rejected:
      props = { ...props, leadingIconName: "icon_abb_dias icon-abb_cancel-circle" }
      break
    case RoleRequestApprovalStatusEnum.Forwarded:
      props = { ...props, leadingIconName: "icon_abb_dias icon-abb_forward" }
      break
    case RoleRequestApprovalStatusEnum.Open:
      props = {
        ...props,
        leadingIconName: "icon_abb_dias icon-abb_time-clock",
        label: "Pending",
      }
      break
    default:
      break
  }

  return props
}
